export const getDismissedFloorsState = (dismissedFloors, floor) => ({
  ...dismissedFloors,
  [floor]: true
});

export { default as getQueryIfNewSearch } from "../helpers/getQueryIfNewSearch";
